/**
 * Validates if a click target should prevent navigation.
 * Returns true if the click should be prevented (e.g., clicking on links, buttons, or specific text).
 *
 * @param target - The HTML element that was clicked
 * @param elementTags - Array of tag names to check (e.g., ['A', 'BUTTON'])
 * @param elementSelectors - Array of CSS selectors to check with closest() (e.g., ['a', 'button'])
 * @param locales - Array of text content strings to match (e.g., ['View More', 'View Less'])
 * @returns true if navigation should be prevented, false otherwise
 */
export const validateClickTarget = (
  target: HTMLElement,
  elementTags: string[],
  elementSelectors: string[],
  locales: string[],
): boolean => {
  return (
    elementTags.includes(target.tagName) ||
    elementSelectors.some((selector) => target.closest(selector) !== null) ||
    locales.includes(target.textContent || '')
  );
};
